export function formatDate(isoDateString) {
  const date = new Date(isoDateString);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthName = months[date.getMonth()];

  const day = date.getDate();

  const year = date.getFullYear();

  return `${monthName} ${day}, ${year}`;
}
